<dx-popup
    [title]="'Clear Exceptions'"
    [(visible)]="visible"
    [fullScreen]="!!(screen.xSmallScreenChanged | async)"
    [width]="480"
    (onHidden)="close()"
    [height]="660"
    (onShowing)="onOpen()"
    [wrapperAttr]="{'class':'form-popup'}"
    [showCloseButton]="true"
>
    <dxi-popup-toolbar-item toolbar="bottom" location="center">
        <div class="form-popup-buttons-container">
            <dx-button
                text="Cancel"
                stylingMode="outlined"
                type="normal"
                (onClick)="close()"
            ></dx-button>
            <dx-button
                text="Save"
                stylingMode="contained"
                type="default"
                (onClick)="onSaveClick()"
            ></dx-button>
        </div>
    </dxi-popup-toolbar-item>
    @if (formData) {
        <dx-form
            class="plain-styled-form"
            id="clear-exceptions-form"
            [screenByWidth]="getSizeQualifier"
            [formData]="formData"
            [showColonAfterLabel]="false"
            [colCount]="12"
        >
            <dxo-col-count-by-screen
                [xs]="1"
                [sm]="6"
                [md]="12"
                [lg]="12"
            ></dxo-col-count-by-screen>

            <dxi-item [colSpan]="12">
                <user-avatar-email
                    [email]="formData.timeLog.employee.email"
                    [name]="formData.timeLog.employee.name"
                    [avatarUrl]="formData.timeLog.employee.avatarUrl"
                ></user-avatar-email>
            </dxi-item>

            <dxi-item [colSpan]="8">
                <dx-select-box
                    label="Shift"
                    stylingMode="filled"
                    valueExpr="id"
                    displayExpr="name"
                    [dataSource]="shiftDataSource"
                    [(value)]="formData.timeLog.shiftId"
                    (onOptionChanged)="onShiftChanged($event)"
                ></dx-select-box>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="4" cssClass="mt-4" [label]="{ visible: false }">
                <dx-check-box
                    text="Mark as absent"
                    [(value)]="formData.isAbsent"
                    [disabled]="formData.timeLog.exceptionType !== ExceptionType.Absent"
                ></dx-check-box>
            </dxi-item>

            <dxi-item [colSpan]="6">
                <dx-date-box
                    label="Scheduled Start Time*"
                    stylingMode="filled"
                    [showClearButton]="true"
                    type="time"
                    dateSerializationFormat="HH:mm"
                    [(value)]="formData.timeLog.shiftStartTime"
                    [disabled]="formData?.isAbsent"
                    pickerType="list"
                ></dx-date-box>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="6">
                @if (showStartSelect) {
                    <dx-select-box
                        label="Actual Start Time"
                        stylingMode="filled"
                        [dataSource]="formData?.timeLog.punchInTimes ?? []"
                        [(value)]="formData.actualStart"
                        [disabled]="formData?.isAbsent"
                        [displayExpr]="displayPunchTime"
                    ></dx-select-box>
                } @else {
                    <dx-date-box
                        label="Actual Start Time"
                        stylingMode="filled"
                        type="time"
                        dateSerializationFormat="HH:mm"
                        [(value)]="formData.actualStart"
                        [disabled]="formData?.isAbsent"
                        pickerType="list"
                    ></dx-date-box>
                }
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="12">
                <div class="d-flex justify-content-between align-items-center">
                    <div>In Status:
                        <contact-status [value]="formData.timeLog.punchInStatus | dasherize"
                                        [text]="formData.timeLog.punchInStatus | capitalCase"></contact-status>
                    </div>
                    <div>Huddle Status:
                        <contact-status [value]="formData.timeLog.huddleStatus | dasherize"
                                        [text]="formData.timeLog.huddleStatus | capitalCase"></contact-status>
                    </div>
                </div>
            </dxi-item>

            <dxi-item [colSpan]="6">
                <dx-date-box
                    label="Scheduled End Time*"
                    stylingMode="filled"
                    [showClearButton]="true"
                    type="time"
                    dateSerializationFormat="HH:mm"
                    [(value)]="formData.timeLog.shiftEndTime"
                    [disabled]="formData?.isAbsent"
                    pickerType="list"
                ></dx-date-box>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="6">
                @if (showEndSelect) {
                    <dx-select-box
                        label="Actual End Time"
                        stylingMode="filled"
                        [dataSource]="formData?.timeLog.punchOutTimes ?? []"
                        [(value)]="formData.actualEnd"
                        [disabled]="formData?.isAbsent"
                        [displayExpr]="displayPunchTime"
                    ></dx-select-box>
                } @else {
                    <dx-date-box
                        label="Actual End Time"
                        stylingMode="filled"
                        [showClearButton]="true"
                        type="time"
                        dateSerializationFormat="HH:mm"
                        [(value)]="formData.actualEnd"
                        [disabled]="formData?.isAbsent"
                        pickerType="list"
                    ></dx-date-box>
                }
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>

            <dxi-item [colSpan]="12">
                <div>Out Status:
                    <contact-status
                        [value]="formData.timeLog.punchOutStatus | dasherize"
                        [text]="formData.timeLog.punchOutStatus | capitalCase"
                    ></contact-status>
                </div>
            </dxi-item>

            <dxi-item [colSpan]="12">
                <div class="d-flex justify-content-between">
                    <div>Scheduled Hours:
                        <strong>{{ formData.timeLog.scheduledHoursSpan ? (formData.timeLog.scheduledHoursSpan | toDate | date: "h'h' m'min'") : '0h 00min' }}</strong>
                    </div>
                    <div>Hours Worked:
                        <strong>{{ formData.timeLog.hoursWorkedSpan ? (formData.timeLog.hoursWorkedSpan | toDate | date: "h'h' m'min'") : '0h 00min' }}</strong>
                    </div>
                </div>
            </dxi-item>

            <dxi-item [colSpan]="12">
                <dx-text-area
                    label="Reason for exception:*"
                    stylingMode="filled"
                    [height]="70"
                    [(value)]="formData.timeLog.clearingExceptionReason"
                ></dx-text-area>
                <dxi-validation-rule type="required"></dxi-validation-rule>
            </dxi-item>
        </dx-form>
    }
</dx-popup>
